<!-- eslint-disable vue/attribute-hyphenation for _groupHover -->
<template>
  <mp-flex :margin-right="!withChild && !isStacked ? '60px' : undefined">
    <!-- max-height="calc(100vh - 60px)" -->
    <mp-box
      :max-height="`calc(100vh - ${bannerHeightTotal + 60}px)`"
      border-right="1px"
      border-color="gray.100"
      transition="all 600ms cubic-bezier(0.4, 0, 0.2, 1) 0s"
      :background-color="withChild ? 'ash.100' : 'background'"
      :position="isStacked ? 'relative' : 'absolute'"
      :width="isToggle ? '3.75rem' : '13.5rem'"
      :max-width="isToggle ? '3.75rem' : '13.5rem'"
      :display="['block']"
      :margin-right="isStacked && !withChild ? '0' : '-60px'"
      z-index="1"
      :box-shadow="sidebarBoxShadow"
    >
      <mp-box
        as="section"
        class="sidebar-content"
        data-id="sidebar"
        width="inherit"
        :height="`calc(100vh - ${bannerHeightTotal + 60}px)`"
        overflow-y="auto"
        overflow-x="hidden"
        padding-top="4"
        padding-x="2"
        padding-bottom="60px"
        @mouseenter="handleMouseEnter()"
        @mouseleave="handleMouseLeave()"
      >
        <mp-box v-for="(menu, index) in menuFiltered" :key="menu.id">
          <mp-flex flex-direction="column" @click="onMenuClick(menu)">
            <mp-pseudo-box
              role="group"
              flex="1"
              border-radius="md"
              :as="isNuxt3Link(menu.link) ? 'a' : 'router-link'"
              :href="isNuxt3Link(menu.link) ? menu.link : null"
              transition="all 600ms cubic-bezier(0.4, 0, 0.2, 1) 0s"
              padding-x="2.5"
              padding-y="2"
              cursor="pointer"
              :to="!isNuxt3Link(menu.link) ? menu.link : null"
              :background-color="menu.isActive ? 'blue.100' : 'inherit'"
              :color="menu.isActive ? 'blue.400' : 'inherit'"
            >
              <mp-flex
                position="relative"
                direction="row"
                align="center"
                justify="space-betwem"
              >
                <mp-box
                  v-if="menu.isShowBagde && isToggle"
                  position="absolute"
                  left="16px"
                  top="0"
                  width="3"
                  height="3"
                  border-radius="full"
                  background="rose.400"
                  border="2px solid"
                  :border-color="withChild ? 'ash.100' : 'background'"
                />
                <mp-stack
                  width="full"
                  direction="row"
                  align="center"
                  justify="space-betwem"
                >
                  <mp-icon
                    :name="menu.icon"
                    :variant="menu.isActive ? 'fill' : 'outline'"
                    :color="menu.isActive ? 'blue.400' : 'gray.600'"
                    :_groupHover="{
                      color: 'blue.400',
                      cursor: 'pointer',
                    }"
                  />
                  <mp-text
                    white-space="nowrap"
                    :font-weight="menu.isActive ? 'semibold' : 'inherit'"
                    :color="menu.isActive ? 'blue.400' : 'dark'"
                    :opacity="isToggle ? '0' : '1'"
                    :_groupHover="{
                      color: 'blue.400',
                      cursor: 'pointer',
                    }"
                  >
                    {{ menu.name }}
                  </mp-text>
                </mp-stack>
                <mp-badge
                  v-if="menu.isNew && !isToggle"
                  variant="solid"
                  variant-color="red"
                >
                  NEW
                </mp-badge>
              </mp-flex>
            </mp-pseudo-box>
          </mp-flex>
          <mp-divider v-if="sidebarDivider(menuFiltered, menu, index)" />
        </mp-box>
        <mp-flex
          gap="2"
          :background-color="withChild ? 'ash.100' : 'background'"
          flex-direction="row"
          position="fixed"
          width="inherit"
          bottom="0"
          left="0"
          align-items="center"
          border-top="1px solid"
          border-right="1px solid"
          border-top-color="gray.100"
          border-right-color="gray.100"
          padding="2"
          h="68px"
        >
          <mp-tooltip
            position="right"
            :show-delay="200"
            :label="
              isStacked
                ? 'Click to collapse or shortcut [shift] + [x]'
                : 'Click to expand or shortcut [shift] + [x]'
            "
            use-portal
          >
            <mp-pseudo-box
              role="group"
              border-radius="sm"
              transition="all 600ms cubic-bezier(0.4, 0, 0.2, 1) 0s"
              padding-x="2.5"
              padding-y="2"
              :_hover="{
                backgroundColor: 'blue.100',
                color: 'blue.400',
                cursor: 'pointer',
              }"
              @click="handleToggle"
            >
              <mp-stack direction="row" align="center">
                <mp-icon
                  :name="isStacked ? 'arrow-collapse' : 'arrow-expand'"
                  size="sm"
                />
              </mp-stack>
            </mp-pseudo-box>
          </mp-tooltip>
          <mp-text
            font-size="sm"
            color="dark"
            white-space="nowrap"
            :opacity="isToggle ? '0' : '1'"
            is-truncated
          >
            Company ID : {{ companyId }}
          </mp-text>
        </mp-flex>
      </mp-box>
    </mp-box>
    <MekariSidebarChild
      v-if="withChild && !isOnCreateTemplate"
      :isStacked="isStacked"
      :menus="menuFiltered"
      :submenus="submenus"
      @toggle="handleChildToggle"
    />
  </mp-flex>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import MekariSidebarChild from './MekariSidebarChild.vue'
import { isQontakLitePackage } from '~/utils/general'
import globalMixin from '~/assets/mixins/global/globalMixin'
import permissionMixin from '~/assets/mixins/permissions/permissionMixin'
import { PackageName } from '~/store/package'

export default {
  name: 'MekariSidebar',
  components: {
    MekariSidebarChild,
  },
  mixins: [globalMixin, permissionMixin],
  props: {
    bannerHeightTotal: {
      type: Number,
      default: 60,
    },
    isCollapsed: [Boolean],
    defaultIsToggle: [Boolean],
    isAlternate: [Boolean],
    isCustom: [Boolean],
    withChild: [Boolean],
    hasSubMenu: [Boolean],
    menus: {
      type: [Array, Object],
      default: () => [],
    },
    submenus: {
      type: [Array, Object],
      default: () => [],
    },
  },
  data() {
    return {
      isStacked: !this.defaultIsToggle,
      isForced: this.isAlternate || false,
      isToggle: this.defaultIsToggle,
      isChildToggle: true,
    }
  },
  computed: {
    ...mapState('template', ['credentials']),
    ...mapState('preferences', ['billing_info']),
    ...mapState('usman', [
      'isUseUsmanPermissions',
      'isLoading',
      'isInitialized',
    ]),
    ...mapState('package', ['isUsePackageCode']),
    ...mapState('layouts', ['appConfig']),
    ...mapState('unified_app', ['isUnifiedApp']),
    ...mapGetters('preferences', ['getAgentCanSendBroadcast']),
    billingInfo() {
      return this.$store.getters['preferences/getBillingInfo']
    },
    isQontakLitePackage() {
      return isQontakLitePackage(this.billing_info)
    },
    isHideSlaManagementtMenu() {
      return !this.billingInfo.sla_dashboard_enabled
    },
    isEnableSettingsMenu() {
      const access = this.canAccessSettings
      // If null, use legacy logic
      if (access === null) {
        return !this.isAgent() && !this.isMember()
      }
      return access
    },
    isEnableIntegrationSetting() {
      const access = this.canAccessIntegrations
      // If null, use legacy logic
      if (access === null) {
        return !this.isAgent() && !this.isMember()
      }
      return access
    },
    isEnableReportsMenu() {
      const access = this.canAccessReports
      // If null, use legacy logic
      if (access === null) {
        return !this.isAgent() && !this.isMember()
      }
      return access
    },
    permissionsInfo() {
      return this.$store.getters['organization/getPermissions']
    },
    isEnableDashboardSetting() {
      const access = this.canAccessDashboard
      const isDashboardUseCasePackageEnabled = () => {
        if (this.$store.state.package.isUsePackageCode) {
          return (
            this.$store.getters['package/isEnableBillingPackage'](
              PackageName['CP-QONTAKCHAT-2025-0020']
            ) ||
            this.$store.getters['package/isEnableBillingPackage'](
              PackageName['QONTAKCHAT-SLA']
            )
          )
        } else {
          return (
            this.billingInfo?.sla_dashboard_enabled ||
            this.permissionsInfo?.customer_insights
          )
        }
      }
      // If null, use legacy logic (sla_dashboard_enabled check)
      if (access === null) {
        return !this.isQontakLitePackage && isDashboardUseCasePackageEnabled()
      }
      return access
    },
    isEnableChatbotMenu() {
      const access = this.canAccessChatbot
      // If null, use legacy logic
      if (access === null) {
        return !this.isAgent() && !this.isMember()
      }
      return access
    },
    isEnableCampaignMenu() {
      // Explicitly depend on USMAN state to ensure reactivity
      const isUsman = this.isUseUsmanPermissions
      const isLoading = this.isLoading

      // If USMAN is loading, deny access
      if (isUsman && isLoading) {
        return false
      }

      const access = this.canAccessCampaign

      // If null, check if it's because USMAN store is not initialized
      if (access === null) {
        // Check if USMAN store is initialized by looking at the store directly
        const usmanStoreState = this.$store.state.usman?.isUseUsmanPermissions

        // If USMAN store is not initialized (undefined), deny access until ready
        if (usmanStoreState === undefined) {
          return false
        }

        // USMAN is initialized but disabled, use legacy logic:
        // - Owners/Admins/Supervisors: allowed by default
        // - Agents/Members: depend on agent_can_send_broadcast setting
        if (this.isAgent() || this.isMember()) {
          return this.getAgentCanSendBroadcast
        }
        return true // Owners/Admins/Supervisors get access
      }
      return access
    },
    isCallPackagePassed() {
      const CP_QC_0004 = this.$store.getters['package/isEnableBillingPackage'](
        PackageName['CP-QONTAKCHAT-2025-0004']
      )
      const CP_QC_0013 = this.$store.getters['package/isEnableBillingPackage'](
        PackageName['CP-QONTAKCHAT-2025-0013']
      )
      const CP_QC_0014 = this.$store.getters['package/isEnableBillingPackage'](
        PackageName['CP-QONTAKCHAT-2025-0014']
      )
      const CP_QC_0015 = this.$store.getters['package/isEnableBillingPackage'](
        PackageName['CP-QONTAKCHAT-2025-0015']
      )
      return CP_QC_0004 && (CP_QC_0013 || CP_QC_0014 || CP_QC_0015)
    },
    isCallPilotProjectPassed() {
      const isCustomEnablementEnabled =
        this.appConfig?.wa_call?.pilot_project?.enabled ?? false
      const TARGET_COMPANY_ID =
        this.appConfig?.wa_call?.pilot_project?.company_ids ?? []
      const isCompanyIdMatch =
        (this.credentials?.[0]?.company_id &&
          TARGET_COMPANY_ID.includes(this.credentials?.[0]?.company_id)) ||
        false
      if (!isCustomEnablementEnabled) return true
      return isCustomEnablementEnabled && isCompanyIdMatch
    },
    isShowCallMenuValidation() {
      /**
       * NOTE:
       * Only handle for non Qontak One, because Qontak One user will handled by bifrost team,
       * since we are using Unified Sidebar for Qontak One user
       */
      return this.isCallPackagePassed && this.isCallPilotProjectPassed
    },
    isCallMasterFlagEnabled() {
      return this.appConfig?.wa_call?.call_menu?.enabled ?? false
    },
    isCommerceMasterFlagEnabled() {
      return this.appConfig?.wa_commerce?.commerce_menu?.enabled ?? false
    },
    hasSubscribedCommerce() {
      return this.$store.getters['package/isEnableBillingPackage'](
        PackageName['CP-QONTAKCHAT-2026-0005']
      )
    },
    isCommerceFeatureEnabled() {
      return this.isCommerceMasterFlagEnabled
    },
    menuFiltered() {
      // Hide menus until USMAN is initialized or while loading
      if (
        !this.isInitialized ||
        (this.isUseUsmanPermissions && this.isLoading)
      ) {
        return []
      }

      let result = [...this.menus]

      // Qontak Lite Package restriction
      if (this.isQontakLitePackage && this.isAgent()) {
        result = result.filter((item) => item.link !== '/whatsapp')
      }

      // Apply unified permission checks
      if (!this.isEnableDashboardSetting) {
        result = result.filter((item) => item.link !== '/dashboard')
      }

      if (!this.isEnableChatbotMenu) {
        result = result.filter((item) => item.name !== 'Chatbot')
      }
      if (!this.isEnableCampaignMenu) {
        result = result.filter((item) => item.name !== 'Campaign')
      }

      if (!this.isEnableIntegrationSetting) {
        result = result.filter((item) => item.name !== 'Integrations')
      }

      if (!this.isEnableSettingsMenu) {
        result = result.filter((item) => item.name !== 'Settings')
      }

      if (!this.isEnableReportsMenu) {
        result = result.filter((item) => item.name !== 'Report')
      }

      // if (!this.isEnabledPackageUsageMenu) {
      //   result = result.filter((item) => item.name !== 'Package usage')
      // }

      if (this.isEnabledPageSubscriptions) {
        result = result.filter((item) => item.name !== 'Package usage')
      } else {
        result = result.filter((item) => item.name !== 'Subscriptions')
      }

      if (!this.isCallMasterFlagEnabled || !this.isShowCallMenuValidation) {
        result = result.filter((item) => item.name !== 'Calls')
      }

      if (!this.isCommerceFeatureEnabled) {
        result = result.filter((item) => item.name !== 'Commerce')
      }

      return result
    },
    companyId() {
      if (this.credentials?.length && this.credentials[0]?.company_id)
        return this.credentials[0]?.company_id
      else return null
    },
    sidebarBoxShadow() {
      if (this.withChild) {
        if (this.isStacked) {
          return 'none'
        } else {
          return 'lg'
        }
      } else if (!this.withChild) {
        if (this.isStacked) {
          return 'none'
        } else {
          return 'lg'
        }
      } else {
        return 'none'
      }
    },
    isOnCreateTemplate() {
      return (
        this.$route.name === 'whatsapp-templates-create' ||
        this.$route.name === 'whatsapp-hsm-create'
      )
    },
    isEnabledPackageUsageMenu() {
      const access = this.canAccessFinancesPackageUsages
      // If null, use legacy logic
      if (access === null) {
        return (
          !this.isAgent() &&
          !this.isMember() &&
          !this.appConfig?.is_centralized_package
        )
      }
      return access
    },
    isEnabledPageSubscriptions() {
      const access = this.canAccessSubscriptions
      return access
    },
  },
  watch: {
    defaultIsToggle: {
      handler(newVal) {
        if (!this.isForced) {
          this.isToggle = newVal
          this.isStacked = !newVal
        }
      },
      immediate: false,
    },
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeydown)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydown)
  },
  methods: {
    sidebarChildCondition() {
      return (
        this.$auth.user &&
        this.submenus.length > 0 &&
        !this.$route.name.includes('finances-package_usage')
      )
    },
    handleMouseEnter() {
      // Only expand on hover if sidebar is collapsed and not permanently expanded
      if (!this.isStacked && this.isToggle) {
        this.isToggle = false
      }
    },
    handleMouseLeave() {
      // Only collapse on mouse leave if not permanently expanded (not stacked)
      if (!this.isStacked) {
        this.isToggle = true
      }
    },
    handleToggle() {
      this.isForced = !this.isForced
      if (this.isCustom) {
        this.isStacked = !this.isStacked
        // When stacked (expanded), isToggle should be false (not collapsed)
        // When not stacked (collapsed), isToggle should be true (collapsed)
        this.isToggle = !this.isStacked
      } else {
        this.isToggle = !this.isToggle
      }
    },
    handleChildToggle(e) {
      this.isChildToggle = e
    },
    handleKeydown(e) {
      const SHIFTKEY = e.shiftKey
      const KEYCODE_X = e.keyCode === 88
      if (SHIFTKEY && KEYCODE_X) {
        this.handleToggle()
      }
    },
    sidebarDivider(menus, menu, index) {
      if (
        index < menus.length - 1 &&
        menus[index + 1].category !== menu.category
      ) {
        return true
      } else if (index === menus.length - 1) {
        return true
      } else {
        return false
      }
    },
    onMenuClick(menu) {
      if (menu.name === 'AI resources') {
        this.storeMixpanelMetric(
          '- Open AI Sources Menu',
          {
            Role: this.$auth.user.role,
            Email: this.$auth.user.email,
            'Company ID': this.getOrganizationForMetric()['Company ID'],
            'Company Name': this.getOrganizationForMetric()['Company Name'],
          },
          'chatbot'
        )
      }
    },
    isNuxt3Link(link) {
      // replace last backslash on link
      link = link.replace(/\/$/, '')
      const nuxt3Links = this.appConfig?.v2_feature_links || []
      return nuxt3Links.includes(link)
    },
  },
}
</script>

<style scoped lang="scss">
/* custom scroll bar */
.sidebar-content::-webkit-scrollbar {
  width: 0px;
}
.sidebar-content::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 10px;
}
.sidebar-content:hover::-webkit-scrollbar {
  width: 0px;
  position: absolute;
}
.sidebar-content:hover::-webkit-scrollbar-thumb {
  background: #8b95a5;
}
a:hover {
  text-decoration: none;
}
</style>
